// custom-reuse-strategy.ts
import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from "@angular/router";

export class CustomRouteReuseStrategyV2 implements RouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Never detach any route
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // Not storing any route
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // No stored routes will be reattached
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    // Return null since we're not reusing any route
    return null;
  }

  // allowing a reuse data variable to be passed so when a page navigates to itself it resets the page
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (curr.data && curr.data["reuse"] === false) {
      console.log("reuse false");
      return false;
    }

    // Default behavior: reuse if the route configuration is the same
    return future.routeConfig === curr.routeConfig;
  }
}
